import { BROKER_SOURCE_OPTIONS } from "../constants/realEstateFilters";

export function hasMapLocation(listing) {
  return (
    listing?.latitude != null &&
    listing?.longitude != null &&
    Number.isFinite(listing.latitude) &&
    Number.isFinite(listing.longitude)
  );
}

export function getListingAreaM2(listing) {
  return listing?.areaM2 ?? listing?.buildingAreaSqM ?? null;
}

export function formatListingLocation(listing) {
  const parts = [listing?.neighborhood, listing?.city].filter(Boolean);
  if (parts.length) {
    return parts.join(", ");
  }

  return listing?.areaId || null;
}

export function computeListingCounts(listings = [], summary = null) {
  const total = summary?.totalProperties ?? listings.length;
  const mapped =
    summary?.listingsWithCoordinates ??
    listings.filter((listing) => hasMapLocation(listing)).length;
  const missingLocation =
    summary?.listingsMissingCoordinates ?? Math.max(0, total - mapped);

  const bySource = summary?.bySource || null;
  const bySourceLabels = bySource
    ? BROKER_SOURCE_OPTIONS.map((option) => ({
        id: option.id,
        label: option.label,
        count: bySource[option.id] ?? 0,
      })).filter((entry) => entry.count > 0)
    : computeBySourceFromListings(listings);

  return { total, mapped, missingLocation, bySourceLabels };
}

function computeBySourceFromListings(listings = []) {
  const counts = Object.fromEntries(BROKER_SOURCE_OPTIONS.map((option) => [option.id, 0]));

  listings.forEach((listing) => {
    const source = listing?.source;
    if (source && counts[source] !== undefined) {
      counts[source] += 1;
    }
  });

  return BROKER_SOURCE_OPTIONS.map((option) => ({
    id: option.id,
    label: option.label,
    count: counts[option.id] ?? 0,
  })).filter((entry) => entry.count > 0);
}
